<template>
  <v-form
    data-cy="deviceForm"
    :data-cy-form-valid="valid ? 'valid' : 'invalid'"
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="deviceFormSubmit"
  >
    <v-text-field
      data-cy="name"
      v-model="device.name"
      :rules="validationRules.name"
      :label="`${$t('device.fields.name')} *`"
      required />

    <v-text-field
      data-cy="imei"
      v-model="device.imei"
      :rules="validationRules.imei"
      :label="`${$t('device.fields.imei')} *`"
      required />

    <v-text-field
      data-cy="refreshRate"
      type="number"
      v-if="!edit"
      :rules="validationRules.refreshRate"
      v-model="device.refreshRate"
      :label="$t('device.fields.refreshRate')"
      required />

    <v-select
      data-cy="deviceType"
      :rules="validationRules.type"
      v-model="device.type"
      :items="deviceTypes"
      :label="$t('device.fields.deviceType')"
      required />

    <v-select
      data-cy="deviceStatus"
      :rules="validationRules.deviceStatus"
      v-if="edit"
      v-model="device.deviceStatus"
      :items="deviceStatusTypes"
      :label="$t('device.fields.deviceStatusType')"
      required />

    <v-text-field
      data-cy="simPhoneNumber"
      v-model="device.simPhoneNumber"
      :rules="validationRules.simPhoneNumber"
      :label="$t('device.fields.simPhoneNumber')" />

    <v-text-field
      data-cy="providerDeviceId"
      v-model="device.externalDeviceId"
      :rules="validationRules.externalDeviceId"
      :label="`${$t('device.fields.externalDeviceId')} *`" />

    <div class="pt-10">
      <v-btn
        data-cy="submitBtn"
        :loading="loading"
        type="submit"
        color="success"
        class="mr-4"
        @click="validate"
      >
        {{ $t('common.form.submit') }}
      </v-btn>

      <v-btn
        data-cy="cancelBtn"
        color="default"
        :to="routeConstants.DASHBOARD_URL"
      >
      {{ $t('common.form.cancel') }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import * as routeConstants from '@/router/constants';
import deviceTypeMixin from '@/mixins/deviceTypes.mixin';
import deviceStatusTypesMixin from '@/mixins/deviceStatusTypes.mixin';
import deviceValidationMixin from '@/mixins/deviceValidationRules';


export default {
  name: 'DeviceForm',
  props: {
    edit: Boolean,
    device: Object,
    loading: Boolean
  },
  data: () => ({
    routeConstants: routeConstants,
    valid: true
  }),
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    deviceFormSubmit() {
      const isFormValid = this.$refs.form.validate();
      
      if(isFormValid) {
        this.valid = true;
        this.$emit('onFormSubmit', this.device);
      } else {
        this.valid = false;
      }
    }
  },
  mixins: [
    deviceTypeMixin,
    deviceStatusTypesMixin,
    deviceValidationMixin
  ]
}
</script>